import React from 'react'
import type { IAdvertisingBannerContext } from './interfaces'

export const AdvertisingBannerContext = React.createContext<IAdvertisingBannerContext>({} as IAdvertisingBannerContext)
